import { useAuth } from '../../contexts/AuthContext';
import { LogOut } from 'lucide-react';

const getInitials = (name: string) =>
  name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

/** Header user section: avatar and logout. Mirrors osdu-insights. */
export const UserMenu = () => {
  const { user, logout } = useAuth();

  const userName = user?.name || user?.username || 'User';

  return (
    <div className="flex items-center gap-1.5 sm:gap-2 md:gap-2.5">
      {/* Avatar */}
      <div className="flex items-center gap-1.5 sm:gap-2" title={`${userName} - Equinor`}>
        <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-200 dark:bg-white/15 flex items-center justify-center text-gray-700 dark:text-white font-semibold text-xs sm:text-sm flex-shrink-0">
          {getInitials(userName)}
        </div>
        <div className="hidden 2xl:flex flex-col">
          <div className="text-sm font-medium text-gray-700 dark:text-gray-200 whitespace-nowrap leading-tight">
            {userName}
          </div>
          <div className="text-[10px] text-gray-500 dark:text-gray-300 whitespace-nowrap leading-tight">Equinor</div>
        </div>
      </div>

      {/* Logout */}
      <button
        onClick={logout}
        className="p-1.5 sm:p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/10 hover:text-gray-900 dark:hover:text-white transition-colors"
        aria-label="Logout"
      >
        <LogOut className="h-4 w-4 sm:h-5 sm:w-5" />
      </button>
    </div>
  );
};

export default UserMenu;
